<template>
<div ref="nav" class="nav" :class="{'nav-fixed':navfixed}">
<div class="nav-wrap" >	
	<div class="wrap clear">
		<!-- <a class="nav-btn  np-btn np-btn-main np-btn-ty pd-lg-md" href="/pcb-quote">{{languagePackage.LANG.quote_now}}</a> -->
		<ul class="nav-list">	
			<!-- <li class="nav-item"><a href="/">Home</a></li> -->
			<template v-for="(v,i) in navsList">
			<li class="nav-item" v-if="v.routeName !== 'product'" :key="i"
				:class="{'active-in':v.href == $route.path 
				|| (v.routeName === 'quote' && $route.path === '/pcb-quote-advance')
				|| (v.routeName === 'pcb_assembly' && $route.path === '/pcb-assembly-quote')
				}"
			>			
				<a :href="hrefShow(v.href)" :target="v.href === '/hqonline' ? '_blank' : v.target ? v.target : '_self' "> 
					{{v.name}} 
					<i v-show="v.hasNewicon" class="new-text-icon-animation" style="right: 6px;">{{languagePackage.LANG[v.hasNewicon] || 'Hot'}}</i>
					<img v-if="v.navIcon" :class="{'new-icon-animation': v.iconAnimation}" style="position: absolute;top: -13px; right: 4px;" :src="v.navIcon">
				</a>
				<template v-if="v.child && v.child.length">
					<div class="nav-sub trans-animate">
						<template v-for="(m,n) in v.child">
							<a :href="hrefShow(m.href)" :target="v.href === '/hqonline' ? '_blank' : v.target ? v.target  : '_self'" :key="100 + n" style="position: relative;min-width: 150px;">
								{{m.name}}
								<img v-if="m.navIcon" :class="{'sub-new-icon-animation': m.iconAnimation}" style="position: absolute;top: -4px; right: 14px;" :src="m.navIcon">
							</a>
						</template>
					</div>
				</template>
			</li>
			<li class="nav-item yui-nav-product" v-else :key="i">
				<a href="/pcb-product" v-text="v.name"> </a>	
				<div class="nav-sub nav-product trans-animate">
					<div class="nav-product-box">
						<div class="nav-product-menu">
							<div class="nav-product-menu-col">
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col1-1.webp`" >
										<b class="title">Printed Circuit Boards</b>
									</dt>
									<dd>
										<a href="/pcb-capabilities">PCB Capability</a>
										<!-- <a href="/service-type/pcb-prototype">Fast PCB Prototype</a> -->
										<a href="/pcb-manufacturing-process" >PCB Manufacturing Process</a>
										<a href="/pcb-vocabulary/hdi-pcbs">HDI PCBs</a>
										<a href="/pcb-vocabulary/thick-copper-pcbs" >Thick Copper PCB</a>
										<a href="/pcb-vocabulary/high-tg-pcbs" >High TG PCBs</a>
										<a href="/pcb-vocabulary/flexible-pcbs" >Flexible PCBs</a>
										<a href="/pcb-vocabulary/high-frequency-pcbs" >High-frequency PCBs</a>
										<a href="/pcb-vocabulary/metal-core-pcbs" >Metal-core PCBs</a>
										<a href="/pcb-vocabulary/rigid-flex-pcbs" >Rigid-flex PCBs</a>
										<a href="/pcb-vocabulary/aluminum-pcb" >Aluminum PCBs</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col1-2.webp`" >
										<b class="title">Surface</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/via-covering">Via Covering</a>
										<a href="/pcb-vocabulary/surface-finish" >Surface Finish</a>
										<a href="/pcb-vocabulary/silkscreen" >Silkscreen</a>
										<a href="/pcb-vocabulary/solder-mask" >Solder mask</a>
									</dd> 			
								</dl>
							</div>
							<div class="nav-product-menu-col">
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col2-1.webp`" >
										<b class="title">PCB Assembly</b>
									</dt>
									<dd>
										<a href="/pcb-assembly-services">PCB Assembly Service</a>
										<a href="/pcb-assembly-capabilities">PCB Assembly Capability</a>
										<a href="/blog/what-are-files-requirements-for-pcba">File Requirements</a>
										<a href="/assembly-process">PCB Assembly Process</a>
										<a href="/blog/a-comprehensive-guide-to-ic-programming-in-pcb-assembly">IC Programming</a>
										<a href="/blog/what-is-dfa-in-design-for-manufacturing-and-assembly">PCBA DFA</a>
										<a href="/pcb-vocabulary/bga-assembly-capabilities">BGA Assembly Capabilities</a>
										<a href="/blog/how-pcb-laser-marking-and-coding-works">Laser Labeling/Coding</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col2-2.webp`" >
										<b class="title">Layer Buildup</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/layer-stack-up">Layer Stack-up</a>
										<a href="/pcb-vocabulary/prepregs-cores-foils" >Prepregs, cores, foils</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col2-3.webp`" >
										<b class="title">Online Tools</b>
									</dt>
									<dd>
										<a href="/pcb-impedance-calculator">PCB Impedance Calculator</a>
									</dd> 			
								</dl>
							</div>
							<div class="nav-product-menu-col">
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col3-1.webp`" >
										<b class="title">PCB Design-Aid & Layout</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/layer-orientation">Layer Orientation</a>
										<a href="/pcb-vocabulary/bga" >BGA</a>
										<a href="/pcb-vocabulary/pcb-price-composition" >PCB Price Composition</a>
										<a href="/pcb-vocabulary/printed-circuit-board-materials" >Printed Circuit Board Materials</a>
										<a href="/pcb-vocabulary/pcb-design-layout" >PCB Design & Layout</a>
										<a href="/pcb-vocabulary/panel-creation" >Panel Creation</a>
										<a href="/pcb-vocabulary/gold-fingers" >Gold Fingers</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col3-2.webp`" >
										<b class="title">Mechanics</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/v-scoring">V-Scoring</a>
										<a href="/pcb-vocabulary/back-drilling" >Back drilling</a>
										<a href="/pcb-vocabulary/pcb-milling" >PCB milling</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col3-3.webp`" >
										<b class="title">SMD-Stencils</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/laser-stencil">Laser Stencil</a>
									</dd> 			
								</dl>
							</div>
							<div class="nav-product-menu-col">
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col4-1.webp`" >
										<b class="title">Quality</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/e-test" >E-Test</a>
										<a href="/pcb-vocabulary/x-ray" >X-RAY</a>
										<a href="/pcb-vocabulary/design-rule-check" >Design Rule Check</a>
										<a href="/pcb-vocabulary/a-o-i" >A.O.I</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col4-2.webp`" >
										<b class="title">Drills & Throughplating</b>
									</dt>
									<dd>
										<a href="/pcb-vocabulary/via-in-pad">Via-in-pad</a>
										<a href="/pcb-vocabulary/blind-buried-vias" >Blind & Buried Vias</a>
										<a href="/pcb-vocabulary/annular-rings" >Annular Rings</a>
										<a href="/pcb-vocabulary/side-plating" >Side plating</a>
										<a href="/pcb-vocabulary/plated-half-holes" >Plated Half-holes/Castellated Holes</a>
										<a href="/pcb-vocabulary/plated-through-slots" >Plated-through Slots</a>
									</dd> 			
								</dl>
								<div class="hr-line"></div>
								<dl>
									<dt>
										<img :src="`${__IMG__}/newNavIcon/product/col4-3.webp`" >
										<b class="title">Factory & Certificate</b>
									</dt>
									<dd>
										<a href="/pcb-factory-VR-visiting/" style="position: relative;">PCB Factory VR Visiting
											<img style="position: absolute;top: 4px; right: 49px;" :src="`${__IMG__}/quote/quoteTag.png?v=4`">
										</a>
										<a href="/assembly-factory-show" >PCB Assembly Factory Show</a>
										<a href="/certificate" >Certificate</a>
									</dd> 			
								</dl>
							</div>
						</div>

						<div class="nav-product-adv">
							<a href="/pcb-quote" style="height: auto !important;line-height: normal !important;">
								<div class="nav-product-adv-box">
									<div class="img-box">
										<img :src="`${__IMG__}/newNavIcon/product/pcb.webp`" >
									</div>
									<div class="pcb-text-box">
										<b>Only <em>$<strong>5</strong></em></b>
										<p>24 hours Turnaround Time</p>
										<span>For 1-2 layers PCB</span>
										<span>Under 100mm*100mm</span>
									</div>
								</div>
							</a>

							<a href="/pcb-assembly-quote"  style="height: auto !important;line-height: normal !important;">
								<div class="nav-product-adv-box" style="margin-top: 15px;">
									<div class="img-box" style="margin-top: 9px;">
										<img :src="`${__IMG__}/newNavIcon/product/pcba.webp`" >
									</div>
									<div class="pcba-text-box">
										<b>Free for 10pcs</b>
										<b style="margin-top: 6px;"><em>50%OFF</em> for 100pcs</b>
										<span>TURNKEY PCB ASSEMBLY</span>
									</div>
								</div>
							</a>
						</div>
					</div>
				</div>					
			</li>
			</template>
			
		</ul>	
	</div>
</div>
</div>
</template>

<script>
export default {
	name:"navs",
	data(){
		return {
			navfixed:false,
			subIsShow: false
		}
	},
	computed:{
		navConfig(){
			console.log(85, this.$store.getters.getNavList)
			return this.$store.getters.getNavList || {};
		},
		languagePackage(){
			return this.$store.getters.getLanguangeData || {LANG:{},MLANG:{}};
		},
		navsList(){
			const list = [
				{
					"name":this.languagePackage.LANG.home,
					"routeName":"home",
					"href":"/"
				},
				{
					"name":this.languagePackage.LANG.pcb_quote,
					"routeName":"quote",
					"href":"/pcb-quote",
					"child":[
						{
							"name": "Standard PCB",
							"href":"/pcb-quote"
						},
						{
							"name": "Advanced PCB",
							"href":"/pcb-quote-advance"
						}
					]
				},
				{
					"name":this.languagePackage.LANG.pcb_assembly,
					"routeName":"pcb_assembly",
					"href":"/pcb-assembly-services",
					"child":[
						{
							"name":this.languagePackage.LANG.pcb_assembly_quote,
							"href":"/pcb-assembly-quote"
						},
						{
							"name":this.languagePackage.LANG.pcb_assembly_service,
							"href":"/pcb-assembly-services"
						},
						{
							"name":'Free Functional Testing',
							"href":"/blog/free-functional-testing"
						}
					]
				},
				// {
				// 	"name":this.languagePackage.LANG.bom_service,
				// 	"routeName":"bom_service",
				// 	"href":"/bom-service"
				// },
				// {
				// 	"name":this.languagePackage.LANG.stencil,
				// 	"routeName":"pcb_stencil_quote",
				// 	"href":"/pcb-stencil-quote"
				// },
				// {
				// 	"name":this.languagePackage.LANG.instant_quote,
				// 	"routeName":"quote",
				// 	"href":"/pcb-quote",
				// 	"navIcon": window.IMGURL + "/index-nav-new.png",
				// 	"iconAnimation": 1,
				// 	"child":[
				// 		{
				// 			"name":this.languagePackage.LANG.pcb_quote,
				// 			"href":"/pcb-quote"
				// 		},
				// 		{
				// 			"name":this.languagePackage.LANG.pcb_assembly_quote,
				// 			"href":"/pcb-assembly-quote"
				// 		},
				// 		{
				// 			"name":this.languagePackage.LANG.pcb_stencil_quote,
				// 			"href":"/pcb-stencil-quote"
				// 		},
				// 		{
				// 			"name":this.languagePackage.LANG.bom_service,
				// 			"href":"/bom-service"
				// 		},
				// 		{
				// 			"name":this.languagePackage.LANG.quote_by_salesperson,
				// 			"href":"/quote-by-sales"
				// 		},
				// 		{
				// 			"name":this.languagePackage.LANG.components_quote,
				// 			"href":"/hqonline",
				// 			"navIcon": window.IMGURL + "/index-nav-new.png",
				// 			"iconAnimation": 1
				// 		}
				// 	]
				// },
				{
					"name":this.languagePackage.LANG.components_sourcing,
					"href":"/hqonline",
					// "hasNewicon":"Hot",
					"routeName":"hqonline",
				},
				{
					"name":this.languagePackage.LANG.dfm_nav_lv1,
					"href":"/free-online-gerber-viewer.html",
					// "hasNewicon":"free",
					"routeName":"dfm",
					target:'_blank',
					"child":[
						{
							"name":this.languagePackage.LANG.dfm_web,
							"href":"/free-online-gerber-viewer.html",
							target:'_blank'
						},
						{
							"name":this.languagePackage.LANG.dfm_home,
							"href":"/dfm",
							target:'_blank'
						},
					]
				},
				{
					"name":this.languagePackage.LANG.product_center,
					"routeName": "product",
					"href":"/pcb-product",
					"child": []
				},
				{
					"name":this.languagePackage.LANG.blog,
					"routeName":"blog",
					"href":"/blog"
				},
				{
					"name":this.languagePackage.LANG.about_us,
					"routeName": ["about","whyus","shipment"],
					"href":"/about-nextpcb",
					"child":[
						{
							"name":this.languagePackage.LANG.about_us,
							"href":"/about-nextpcb"
						},
						{
							"name":this.languagePackage.LANG.contact_us,
							"href":"/contactus"
						},
						{
							"name":this.languagePackage.LANG.why_us,
							"href":"/why-us"
						},
						{
							"name":this.languagePackage.LANG.feedback,
							"href":"/feedback"
						},
						{
							"name":this.languagePackage.LANG.faq,
							"href":"https://nextpcb.zohodesk.com.cn/portal/en/kb"
						},
						// {
						// 	"name":this.languagePackage.LANG.vr_visit,
						// 	"href":"/pcb-factory-VR-visiting",
						// 	"navIcon": window.IMGURL + "/quote/quoteTag.png"
						// },
						{
							"name":this.languagePackage.LANG.payments_method,
							"href":"/payment"
						},
						// {
						// 	"name":this.languagePackage.LANG.smt_factory_show,
						// 	"href":"/assembly-factory-show"
						// },
						{
							"name":this.languagePackage.LANG.shipping_methods,
							"href":"/shipment"
						}
						// {
						// 	"name":this.languagePackage.LANG.certiticate,
						// 	"href":"/certificate"
						// }
					]
				}
			]
			for(let i in list) {
				if(list[i].routeName == 'product') {
					list[i].child = this.navConfig.productCenterChild || []
					break
				}
			}	
			return list
		},
		__IMG__(){
			return process?.env?.VUE_APP_STATIC + '/images'
		}
	},
	mounted(){
		window.addEventListener('scroll', this.handleFixed)
		window.addEventListener('resize', this.handleResize)
		const prodSub = document.getElementsByClassName('yui-nav-product')[0]
		prodSub.addEventListener('mouseenter', () => {
			this.subIsShow = true
			document.getElementsByClassName('nav-product')[0].classList.remove('hide-hover-sub')
		})
		prodSub.addEventListener('mouseleave', () => {
			this.subIsShow = false
			document.getElementsByClassName('nav-product')[0].classList.add('hide-hover-sub')
		})
	},
	beforeDestroy(){
		window.removeEventListener('scroll', this.handleFixed)
		window.removeEventListener('resize', this.handleResize)
	},
	methods: {
		// 导航跳转链接
		hrefShow(href) {
			if(href === '/hqonline') {
				return this.$tools.getHqonlineUrl()
			} else {
				return href
			}
		},
		handleFixed(){
			let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;	
			let offsetTop = this.$refs.nav.offsetTop;
			if(scrolltop > offsetTop){
				this.navfixed = true;
			}else{
				this.navfixed = false;
			}
			this.$store.commit('setIsFixed',this.navfixed)
			if (this.subIsShow) {
				document.getElementsByClassName('yui-nav-product')[0].dispatchEvent(new MouseEvent('mouseleave'))
			}
		},
		handleResize(){
			let flag = false
			const wWidth = window.innerWidth
			if(wWidth < 1240){
				flag = true
			}
			this.$store.commit('setIsMinWidth',flag)
		}
	}
	
}
</script>

<style lang="scss">
$navHeight: 48px;
$subitemHeight: 30px;
.nav {
	position: relative;
	z-index: 23;
	height: $navHeight;
	&-wrap {
		background-color: #fff;
		height: $navHeight;
	}
	&-list {
		display: flex;
		position: relative;
    // justify-content: space-between;
	}
	//-fixed
	&-fixed {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 101;
	}
	//nav-btn
	&-btn {
		float: right;
		margin-top: 9px;
	}
	//nav-item
	&-item {
		display: inline-block;
		&>a {
			line-height: $navHeight;
			color: $color-gray-xl;
			font-weight: bold;
			padding: 0 20px;	
			font-size: 14px;
			position: relative;
			letter-spacing: 0.28px;
		}
		&:first-child {
			&>a {
				padding-left: 0;
			}
		}
		&:hover,&.active {
			// background: #180444;
			&>a {
				color: #CC0000;
			}
			.nav-sub {
				position: absolute;
				display: block;
				margin-left: 10px;
				background-color: $color-bg-bs;
				box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
			}
		}
	}
	//nav-sub
	&-sub {
		display: none;
		padding: $space-padding-sm $space-padding-md;
		a {
			display: block;
			height: $subitemHeight !important;
			line-height: $subitemHeight !important;
			
			&:hover{
				color: #CC0000;
				text-decoration: underline;
			}
		}
		.nav-product-box dd a{
			position: relative;
		}
	}
	//nav-product
	&-product {
		width: 1200px;
		box-sizing: border-box;
		padding: 25px 30px;
		margin-left: 0 !important;
		left: 0;
		// left: 50%;
		// transform: translateX(-50%);

		&-box {
			width: 100%;
			font-size: 0;
			display: flex;
			justify-content: space-between;
			box-sizing: border-box;
		}

		&-menu {
			width: 890px;
			display: flex;
			justify-content: space-between;
			flex: 1;

			&-col {
				width: 200px;
				.hr-line {
					width: 100%;
					height: 1px;
					border-bottom: 1px solid #e1e1e1;
					margin: 10px 0 13px;
				}
				dt {
					img {
						width: 28px;
					}
					.title {
						display: block;
						font-size: 14px;
						font-weight: 700;
						line-height: 30px;
						position: relative;
						&::after {
							content: '';
							display: block;
							width: 43px;
							height: 1px;
							border-bottom: 1px solid #cc0000;
							position: absolute;
							left: 0;
							bottom: 0;
						}
					}
				}
				dd {
					margin-top: 5px;
					a {
						font-size: 12px;
						line-height: 22px !important;
						height: 22px !important;
						white-space: nowrap;
						display: block;
						&:hover{
							color: #cc0000;
							text-decoration: underline;
						}
					}
				}
			}
		}

		&-adv {
			width: 250px;
			box-sizing: border-box;
			padding: 5px 0;
			margin-left: 30px;

			a {
				height: auto;
				line-height: normal;
				&:hover {
					color: unset;
					text-decoration: none;
				}
			}

			&-box {
				width: 100%;
				height: 255px;
				background: #f5f6f8;
				box-sizing: border-box;
				padding: 10px 0;

				.img-box {
					width: 100%;
					img {
						width: 132px;
					}
					text-align: center;
				}

				.pcb-text-box{
					box-sizing: border-box;
					padding: 0 28px;
					b {
						display: block;
						font-size: 22px;
						font-weight: 700;
						
						em {
							font-size: 22px;
							font-weight: 700;
							display: inline-block;
							color: #cc0000;
							strong {
								font-size: 28px;
							}
						}
					}

					p {
						font-size: 14px;
						font-weight: 700;
						margin: 8px 0 11px 0;
					}

					span {
						font-size: 12px;
						line-height: 20px;
						display: block;
					}
				}

				.pcba-text-box{
					margin-top: 8px;
					box-sizing: border-box;
					padding: 0 25px;
					b {
						display: block;
						font-size: 20px;
						font-weight: 700;
						line-height: 26px;
						
						em {
							font-size: 20px;
							font-weight: 700;
							display: inline-block;
							color: #cc0000;
						}
					}

					span {
						font-size: 12px;
						line-height: 22px;
						display: block;
						margin-top: 16px;
					}
				}
			}
		}
	}
	//active-in
	.active-in {
		&>a {
			font-weight: 700;
			color: #CC0000;
		}
	}

	@keyframes movepoint {
    25% {
      top: -12px
    }
    100% {
      top: -16px
    }
	}
	.new-text-icon-animation {
		position: absolute;
    top: -16px;
    right: 0px;
    background: #CC0000;
    font-size: 12px;
    color: #fff;
    height: 14px;
    line-height: 14px;
    border-radius: 3px;
    padding: 1px 2px;
		animation: movepoint 2s infinite;
		&::before {
			content: '';
			width: 0;
			height: 0;
			border-left: 3px solid transparent;
			border-right: 3px solid transparent;
			border-top: 3px solid #CC0000;
			position: absolute;
			left: 10px;
			bottom: -2px;
		}
	}
	.new-icon-animation {
		animation: movepoint 2s infinite;
	}

	@keyframes sub-movepoint {
		25% {
			top: 0px
		}
		100% {
			top: -4px
		}
	}
	.sub-new-icon-animation {
		animation: sub-movepoint 2s infinite;
	}
}
</style>
